import { useEffect, useMemo, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

function useCompanyUsers(companyId) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const usersRef = useMemo(() => {
    if (!companyId) return null;
    return collection(db, 'user_data', companyId, 'users');
  }, [companyId]);

  useEffect(() => {
    if (!usersRef) {
      setUsers([]);
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    const unsub = onSnapshot(
      usersRef,
      (snapshot) => {
        setUsers(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error(err);
        setError(err);
        setLoading(false);
      }
    );
    return unsub;
  }, [usersRef]);

  return { users, loading, error };
}

export default useCompanyUsers;

